define('cartware_checkout/components/selects',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware/dom/event/trigger",
	"select2"
], function(
	$,
	_,
	Component,
	BEM,
	triggerEvent,
	S2
) {
	return Component.create({
		block:		null,

		$init: function() {
			this.block = BEM.block("cartware-checkout");

			this.transformSelects();

			var debounceTransform = _.debounce(_.bind(this.transformSelects, this), 10);

			$(document).ajaxComplete(debounceTransform);
			Ajax.Responders.register({
				onComplete: debounceTransform
			});
		},

		transformSelects: function() {
			var self = this;
			$.fn.select2.amd.require(
				["select2/utils", "select2/dropdown", "select2/dropdown/attachContainer", "select2/dropdown/closeOnSelect", "select2/dropdown/search"],
				function (Utils, Dropdown, AttachContainer, CloseOnSelect, Search) {
					self.block.find("select").each(function() {
						var select = $(this),
							features = (''+select.data("ui-select-features")).split(" "),
							dropdownAdapter;

						if (select.data('select2')) return;

						dropdownAdapter = Utils.Decorate(Utils.Decorate(Dropdown, AttachContainer), CloseOnSelect);

						if (features.indexOf("search") >= 0) {
							dropdownAdapter = Utils.Decorate(dropdownAdapter, Search);
						}

						select.select2({
							dropdownAdapter: dropdownAdapter,
							width: null
						});

						select.data("select2").$container.css("display", this.style.display === "none" ? "none" : "");

						select.on("change", function(e) {
							if ("undefined" === typeof e.originalEvent) {
							//if (e instanceof $.Event) {
								triggerEvent(this, "change");
							}
						});
					});
				}
			);
		}
	});
});
